export enum AppFeatures {
  Patients = 'patients',
  Orders = 'orders',
  Results = 'results',
  BatchResults = 'batch-results',
  Manifests = 'manifests',
  SupplyOrders = 'supply-orders',
  PriceEstimator = 'price-estimator',
  EmrOrders = 'emr-orders',
  GlobalResultsSearch = 'global-results-search',
  GlobalResultsReports = 'global-results-reports',
  PreaccessionManifests = 'preaccession-manifests',
  Analytics = 'analytics',
  OrderRequisitionBatch = 'order-requisition-batch'
}
